module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.dataReady) ? _c('div', {
    staticClass: "article privacy"
  }, [_c('header', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.page && _vm.page.title && _vm.page.title.rendered)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "post-content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.content.rendered)
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dce3f7b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Privacy.vue
// module id = 368
// module chunks = 0